import { render, staticRenderFns } from "./SignOut.vue?vue&type=template&id=0b5f2a6e&scoped=true&"
import script from "./SignOut.vue?vue&type=script&lang=js&"
export * from "./SignOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f2a6e",
  null
  
)

export default component.exports